export enum TOsdActiveAction {
  idle = "idle",
  drawing = "drawing",
  removing = "removing",
  selecting = "selecting",
  free = "free",
}
